(function () {
  function quoteInfoTransit() {
    let desktopWrap = $('.js-quote-side-info-desktop'),
      mobileWrap = $('.js-quote-side-info-mobile'),
      item = $('.js-quote-side-info');
    if (window.matchMedia('(min-width: 1200px)').matches) {
      if (!desktopWrap.find(item).length) {
        item.appendTo(desktopWrap);
      }
    } else if (window.matchMedia('(max-width: 767px)').matches) {
      if (!desktopWrap.find(item).length) {
        item.appendTo(desktopWrap);
      }
    } else {
      if (!mobileWrap.find(item).length) {
        item.appendTo(mobileWrap);
      }
    }
  }

  $(function () {
    quoteInfoTransit();
  });

  var resizeTimer;

  $(window).on('resize orientationchange', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      quoteInfoTransit();
    }, 250);
  });
})();
